import { useQuery } from '@tanstack/react-query'
import type { TouchEvent } from 'react'
import { Link } from 'react-router-dom'
import { Autoplay } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import styled from 'styled-components'

import { QUERY_KEY } from '../../../constants'

import { getNewsList } from '../../../api/news'

import { AlignCenterItem } from '../../../components/common'
import { Text } from '../../../components/text'

import { Color } from '../../../theme/color'

import { ReactComponent as ArrowRightGrayIcon } from '../../../assets/ico/common/arrow/right/arrow_right_gray_18.svg'

import 'swiper/css'

export function NewsBanner() {
  const { data, isPending, isError } = useQuery({
    queryKey: [QUERY_KEY.news, 'home'],
    queryFn: () => getNewsList({ size: 5 }),
  })

  const disabledScroll = (e: TouchEvent<HTMLDivElement>) => e.stopPropagation()

  if (isPending || isError) return null

  if (!data.list.length) return null

  return (
    <Container $gap={12} onTouchStart={disabledScroll}>
      <Swiper
        modules={[Autoplay]}
        loop={true}
        direction="vertical"
        nested={true}
        touchMoveStopPropagation={true}
        touchStartPreventDefault={false}
        autoplay={{ delay: 5000 }}
      >
        {data.list.map(({ id, title, linkUrl }) => {
          const route = () => window.open(linkUrl)

          return (
            <SwiperSlide key={id} onClick={route}>
              <Text size={14} weight={500} block={true} $textOverflow="ellipsis">
                {title}
              </Text>
            </SwiperSlide>
          )
        })}
      </Swiper>
      <MoreButton>
        <Link to="/news">
          <Text size={12} weight={500} color="text_secondary" block={true}>
            더보기
          </Text>
          <ArrowRightGrayIcon />
        </Link>
      </MoreButton>
    </Container>
  )
}

const Container = styled(AlignCenterItem)`
  width: calc(100% - 32px);
  height: 42px;
  margin: 0 16px;
  padding: 0 16px;
  border: 1px solid ${Color.line};
  border-radius: 8px;
  background-color: ${Color.gray_1};
  .swiper {
    width: 100%;
    height: 100%;
    touch-action: none;
    .swiper-slide {
      display: flex;
      align-items: center;
      width: 100%;
      span {
        width: 100%;
      }
    }
  }
`

const MoreButton = styled(AlignCenterItem)`
  flex-shrink: 0;
  > a {
    display: flex;
    align-items: center;
  }
`
